/** @format */

import {useEffect} from 'react';

import {Route, Routes} from 'react-router-dom';

import {useMixpanelContext} from 'contexts/MixpanelContext';

import {ROUTES} from 'constants/ROUTES';

import {RedirectTo} from './RedirectTo';
import ResetPassword from './ResetPassword';
import SignIn from './SignIn';
import SignUp from './SignUp';
import VerifyCode from './VerifyCode';

const Auth = () => {
  const {mixpanel, setup} = useMixpanelContext();

  useEffect(() => {
    // Initialize Mixpanel before tracking events
    setup();
    mixpanel.track('visit_app_landing');
  }, [mixpanel, setup]);

  return (
    <Routes>
      {/* Canonical routes */}
      <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
      <Route path={ROUTES.SIGN_UP} element={<SignUp />} />
      <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={ROUTES.VERIFY_CODE} element={<VerifyCode />} />

      {/* Redirects from retired routes */}
      <Route path={ROUTES.EMAIL_SING_IN} element={<RedirectTo to='/auth/sign-in?mode=email' />} />
      <Route path={ROUTES.PHONE_SIGN_UP} element={<RedirectTo to='/auth/sign-up' />} />
      <Route path={ROUTES.EMAIL_SING_UP} element={<RedirectTo to='/auth/sign-up' />} />
      <Route
        path={ROUTES.PHONE_RESET_PASSWORD}
        element={<RedirectTo to='/auth/reset-password' />}
      />
      <Route
        path={ROUTES.EMAIL_RESET_PASSWORD}
        element={<RedirectTo to='/auth/reset-password?mode=email' />}
      />
      <Route path={ROUTES.RESET_PASSWORD_SENT} element={<RedirectTo to='/auth/reset-password' />} />

      <Route index element={<SignIn />} />
    </Routes>
  );
};

export default Auth;
